import React, { useState } from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import Modal from './Modal';
import ContactForm from './ContactForm';

export default function CallToAction() {
  const [showContactForm, setShowContactForm] = useState(false);

  const scrollToEstimation = () => {
    const element = document.getElementById('estimation-rapide');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <section className="py-8 sm:py-12 lg:py-16 bg-white relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            {/* First Card */}
            <div className="space-y-6 sm:space-y-8">
              <div 
                className="bg-white/80 backdrop-blur-xl shadow-[0_8px_32px_rgba(42,67,101,0.15)]
                  transform hover:scale-[1.02] transition-all duration-300
                  relative overflow-hidden rounded-xl group
                  before:content-[''] before:absolute before:inset-0
                  before:bg-gradient-to-b before:from-white/30 before:to-[#2A4365]/10 before:pointer-events-none
                  [transform-style:preserve-3d] hover:[transform:perspective(1000px)_rotateX(2deg)]
                  after:content-[''] after:absolute after:inset-0
                  after:bg-gradient-to-r after:from-[#2A4365]/10 after:via-[#4A5568]/10 after:to-[#C4A052]/10 
                  after:pointer-events-none"
              >
                <div className="relative h-64 sm:h-[450px] overflow-hidden">
                  <img
                    src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1280&q=80"
                    alt="Modern luxury home"
                    className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
                  <div className="absolute bottom-6 sm:bottom-8 left-0 right-0 p-4 sm:p-8 text-center">
                    <h3 className="text-xl sm:text-2xl lg:text-[2.2rem] font-bold text-white mb-2 sm:mb-4 leading-tight">
                      Estimation en ligne gratuite
                    </h3>
                    <p className="text-white/90 text-sm sm:text-base lg:text-lg">
                      Obtenez une estimation précise de votre bien en quelques minutes
                    </p>
                  </div>
                </div>
              </div>

              <button
                onClick={scrollToEstimation}
                className="w-full flex items-center justify-center px-4 sm:px-8 py-3 sm:py-4 text-base sm:text-lg font-medium rounded-xl text-white
                  bg-gradient-to-r from-[#2A4365] via-[#4A5568] to-[#C4A052]
                  hover:from-[#1A3355] hover:via-[#3A4558] hover:to-[#B49042]
                  focus:outline-none focus:ring-2 focus:ring-[#2A4365] focus:ring-offset-2
                  transform transition-all duration-300 hover:scale-105
                  shadow-lg hover:shadow-xl hover:shadow-[#2A4365]/20"
              >
                Démarrer l'estimation
                <ArrowRight className="ml-2 h-5 w-5 sm:h-6 sm:w-6" strokeWidth={2.5} />
              </button>
            </div>

            {/* Second Card */}
            <div className="space-y-6 sm:space-y-8">
              <div 
                className="bg-white/80 backdrop-blur-xl shadow-[0_8px_32px_rgba(42,67,101,0.15)]
                  transform hover:scale-[1.02] transition-all duration-300
                  relative overflow-hidden rounded-xl group
                  before:content-[''] before:absolute before:inset-0
                  before:bg-gradient-to-b before:from-white/30 before:to-[#4A5568]/10 before:pointer-events-none
                  [transform-style:preserve-3d] hover:[transform:perspective(1000px)_rotateX(2deg)]
                  after:content-[''] after:absolute after:inset-0
                  after:bg-gradient-to-r after:from-[#4A5568]/10 after:via-[#C4A052]/10 after:to-[#2A4365]/10 
                  after:pointer-events-none"
              >
                <div className="relative h-64 sm:h-[450px] overflow-hidden">
                  <img
                    src="https://images.unsplash.com/photo-1573496130141-209d200cebd8?auto=format&fit=crop&w=1280&q=80"
                    alt="Professional real estate agent"
                    className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
                  <div className="absolute bottom-6 sm:bottom-8 left-0 right-0 p-4 sm:p-8 text-center">
                    <h3 className="text-xl sm:text-2xl lg:text-[2.2rem] font-bold text-white mb-2 sm:mb-4 leading-tight">
                      Parler à un expert
                    </h3>
                    <p className="text-white/90 text-sm sm:text-base lg:text-lg">
                      Échangez avec l'un de nos experts immobiliers
                    </p>
                  </div>
                </div>
              </div>

              <button
                onClick={() => setShowContactForm(true)}
                className="w-full flex items-center justify-center px-4 sm:px-8 py-3 sm:py-4 text-base sm:text-lg font-medium rounded-xl text-white
                  bg-gradient-to-r from-[#2A4365] via-[#4A5568] to-[#C4A052]
                  hover:from-[#1A3355] hover:via-[#3A4558] hover:to-[#B49042]
                  focus:outline-none focus:ring-2 focus:ring-[#2A4365] focus:ring-offset-2
                  transform transition-all duration-300 hover:scale-105
                  shadow-lg hover:shadow-xl hover:shadow-[#2A4365]/20"
              >
                Nous contacter
                <Phone className="ml-2 h-5 w-5 sm:h-6 sm:w-6" strokeWidth={2.5} />
              </button>
            </div>
          </div>
        </div>
      </section>

      <Modal isOpen={showContactForm} onClose={() => setShowContactForm(false)}>
        <ContactForm onClose={() => setShowContactForm(false)} />
      </Modal>
    </>
  );
}